/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "local 0.1.0",
    versionChannel: "local",
    buildDate: "2026-04-03T16:45:48.893Z",
    commitHash: "83f91f29496c3d164e4a02034894342c80aeaa2f",
};
